<template>
    <div>
        <div v-if="items.length === 0" class="row-center row m-b-4 row-middle">
            <div class="column p-l-0">
                <h1 class="f-s-7 m-b-0">
                    {{ trans('Ready For Take Off?') }}
                    <br />
                    {{ trans("Let's Get Your Course Started") }}
                </h1>
                <p class="c-muted m-t-3 f-s-5">
                    {{ trans("You've mapped out your content and you're ready to start getting it online. Don't waste any more time, click the button below to start adding your videos, files and training content today!") }}
                </p>
                <a v-bind:href="addLessonUrl" class="btn btn-primary m-t-2">{{ trans('Add Your First Lesson') }}</a>
            </div>
            <div class="medium-6">
                <img class="p-l-8 p-r-8" src="/img/empty-course.png" />
            </div>
        </div>
        <div v-else v-sortable="{ onUpdate: onUpdate, handle: '.handle' }">
            <module
                 v-for="(module, index) in items"
                 v-bind:key="'module-' + module.id"
                 v-bind:item="module"
                 v-bind:index="index"
                 v-bind:add-lesson-url="addLessonUrl"
                 v-bind:selected.sync="selected"
                 v-bind:expanded="isExpanded(module)"
                 v-bind:data-encoded-id="module.encoded_id"
                 v-on:show-modal-edit="showModalEdit"
                 v-on:module:cloned="insertModule"
                 v-on:expanded="storeModuleExpandedState(module, ...arguments)"
            ></module>
        </div>
        <new-module-modal
            v-on:close="modalNew.show = false"
            v-on:add-module="addModule"
            ref="new-module-modal">
        </new-module-modal>
        <edit-module-modal
            v-on:close="modalEdit.show = false"
            v-on:save-module="saveModule"
            v-on:delete-module="deleteModule"
            ref="edit-module-modal">
        </edit-module-modal>
    </div>
</template>
<script>
import Orderable from '../mixins/Orderable.js';
import Module from './Module.vue';
import { lessonCreateLink, moduleStoreLink, moduleUpdateLink, moduleDeleteLink } from '../routes.js';

export default {
    mixins: [Orderable],
    components: {
        Module
    },
    props: {
        hub: {
            type: Object,
            required: true,
        },
        modules: {
            type: Array,
        },
    },
    data() {
        return {
            items: this.modules,
            model: 'Kourses\\Module',
            checked: [],
            selected: null,
            addModuleUrl: moduleStoreLink(this.hub),
            addLessonUrl: lessonCreateLink(this.hub),
            expandedModules: new Set(),
        }
    },
    methods: {
        showModalNew() {
            this.modalNew.show = true;
        },
        addModule(module, createLesson) {
            window.axios
                .post(this.addModuleUrl, module)
                .then((response) => {
                    // If add and add lesson is clicked
                    if (createLesson) {
                        window.location.href = this.addLessonUrl + '?module_id=' + response.data.encoded_id;
                    } else {
                        this.items.push(response.data);
                        this.modalNew.show = false;
                        this.modalNew.reset();

                        this.$emit('modules:count', this.items.length);
                    }
                })
                .catch((error) => {
                    this.modalNew.errors.record(error.response.data);
                });
        },
        showModalEdit(module, index) {
            this.modalEdit.module = module;
            this.modalEdit.index = index;
            this.modalEdit.show = true;
        },
        saveModule(module, index) {
            window.axios
                .put(moduleUpdateLink(module), module)
                .then(() => {
                    this.items.splice(index, 1, module);
                    this.modalEdit.show = false;
                    this.modalEdit.reset();
                })
                .catch((error) => {
                    this.modalEdit.errors.record(error.response.data);
                });
        },
        deleteModule(module, index) {
            this.$dialog.confirm(this.trans("By deleting module you'll also delete its lessons!"), {loader: true})
                .then((dialog) => {
                    window.axios
                        .delete(moduleDeleteLink(module))
                        .then(() => {
                            this.items.splice(index, 1);
                            this.modalEdit.show = false;
                            this.modalEdit.reset();
                            dialog.close();

                            this.$emit('modules:count', this.items.length);
                        });
                });
        },
        isSelected(moduleId) {
            return this.selected === moduleId;
        },
        toggle(moduleId) {
            this.selected = this.selected !== moduleId ? moduleId : null;
        },
        insertModule(module, index) {
            this.items.splice(index, 0, module);
        },
        isExpanded(module) {
            if (this.expandedModules.size === 0 && this.items[0].encoded_id === module.encoded_id) {
                // If no expanded modules, default to first module but save it as well
                this.storeModuleExpandedState(module, true);

                return true;
            }

            return this.expandedModules.has(module.encoded_id);
        },
        storeModuleExpandedState(module, expanded) {
            const key = `expanded_modules_${this.hub.encoded_id}`;

            if (expanded) {
                this.expandedModules.add(module.encoded_id);
            } else {
                this.expandedModules.delete(module.encoded_id);
            }

            localStorage.setItem(key, JSON.stringify(Array.from(this.expandedModules)));
        },
        loadExpanedState() {
            // Get expanded modules from local storage if available
            const key = `expanded_modules_${this.hub.encoded_id}`;
            const expandedModules = JSON.parse(localStorage.getItem(key) || '[]');
            this.expandedModules = new Set(expandedModules);
        },
    },
    created() {
        if (this.items.length > 0) {
            this.loadExpanedState();
        }
    },
    mounted() {
        this.modalNew = this.$refs['new-module-modal'];
        this.modalEdit = this.$refs['edit-module-modal'];
    },
}
</script>